import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthenticationModalComponent } from './authentication-modal/authentication-modal.component';
import { RegisterComponent } from './register/register.component';
import { AlertModule, ButtonModule, CarouselSliderModule, InputModule, LocalLoaderModule, SosLoaderModule } from '@serviceos-ng/core';
import { LoginComponent } from './login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ClaimAccountComponent } from './claim-account/claim-account.component';
import { CardComponent } from './card/card.component';
import { TabsComponent } from './tabs/tabs.component';
import { FootnoteBoxComponent } from './footnote-box/footnote-box.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MergeAccountComponent } from './merge-account/merge-account.component';



@NgModule({
  declarations: [AuthenticationModalComponent, LoginComponent, RegisterComponent, ResetPasswordComponent, ClaimAccountComponent, CardComponent, TabsComponent, FootnoteBoxComponent, RecoverPasswordComponent, MergeAccountComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    InputModule,
    AlertModule,
    LocalLoaderModule,
    NgxIntlTelInputModule,
    SosLoaderModule,
    CarouselSliderModule
  ],
  exports: [
    AuthenticationModalComponent,
    LoginComponent, 
    RegisterComponent, 
    ResetPasswordComponent, 
    ClaimAccountComponent,
    CardComponent,
    TabsComponent,
    FootnoteBoxComponent,
    RecoverPasswordComponent,
    MergeAccountComponent
  ]
})
export class AuthenticationModule { }
